import React, { Component } from 'react';
import privy from '../../assets/logo-privy-colored.png';
import peruri from '../../assets/Logo-peruri.png';
import vida from '../../assets/vida.png';
import digisign from '../../assets/digisign-black.png';
import bppt from '../../assets/logo-bppt.png'
import bsre from '../../assets/logo-bsre.png'

export default () =>{
  return (
    <section className="psre-lima">
    <div className="container mx-auto text-center">
      <div className="col-lg-7 col-md-8 col-sm-12 col-12 mx-auto">
        <p className="mb-5" style={{fontSize: '20px', fontWeight: '600'}}>Penyelenggara Sertifikasi Elektronik</p><img className="mt-2 mr-5 mb-5" src={privy} alt="logo-privy-colored" style={{width: 'auto', height: '40px'}} /><img className="mt-2 mr-5 mb-5" src={peruri} alt="Logo-peruri" style={{width: 'auto', height: '40px'}} /><img className="mb-5" src={vida}alt="logo-vida" style={{width: 'auto', height: '55px'}} /><img className="mr-5" src={bppt} alt="logo-bppt" style={{width: 'auto', height: '65px'}} /><img className="mt-1" src={digisign} alt="digisign-black" style={{width: 'auto', height: '45px'}} /><img className="mt-1" src={bsre} alt="digisign-black" style={{width: '150px', height: '65px'}} />
      </div>
    </div>
  </section>
  )
}
